import React, { useEffect, useState } from "react";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";

export default function EditBedType() {

    const navigate = useNavigate();


    const existingData = {
        bedType: "King Bed",
        iconUrl: "url",
    };

    const [bedType, setBedType] = useState("");
    const [icon, setIcon] = useState(null);
    const [iconPreview, setIconPreview] = useState("");

    const [bedTypeError, setBedTypeError] = useState("");
    const [iconError, setIconError] = useState("");


    useEffect(() => {
        setBedType(existingData.bedType);
        setIconPreview(existingData.iconUrl);
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();

        let newError = false;

        if (!bedType.trim()) {
            setBedTypeError("Please enter bed type");
            newError = true;
        } else {
            setBedTypeError("");
        }


        if (!iconPreview) {
            setIconError("Please upload icon file");
            newError = true;
        } else {
            setIconError("");
        }

        if (newError) return;

        console.log("Updated Bed Type:", bedType);
        console.log("icons:", icon);


        navigate(-1);
    };

    return (
        <>

            <div className="breadcrumb-bar mb-2">
                <div className="breadcrumb-left">
                    <Link to="/admin/home" className="breadcrumb-link active">
                        Home
                    </Link>

                    <span className="breadcrumb-separator">|</span>

                    <span className="breadcrumb-link inactive" onClick={() => navigate("/admin/editbed-type/:id")}> Edit BedType</span>
                </div>

                {/* Right: Button */}
                <Button
                    className="add-outlet-btn"
                    onClick={() => navigate("/admin/bedtype")}
                >
                    Bedtypelist
                </Button>
            </div>
            <Container fluid className="p-4">

                <Card className="p-4 border-0">
                    <Form onSubmit={handleSubmit}>
                        <Row className="mb-4 align-items-start">

                            {/* --- > Bed Type */}

                            <Col md={6} sm={12}>
                                <Form.Label>
                                    Bed Type
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    value={bedType}
                                    onChange={(e) => {
                                        setBedType(e.target.value);
                                        setBedTypeError("");
                                    }}
                                />
                                {bedTypeError && (
                                    <div className="text-danger small mt-1">
                                        {bedTypeError}
                                    </div>
                                )}
                            </Col>

                            {/* Icon <---- */}
                            <Col md={6} sm={12}>
                                <Form.Label>
                                    Icon
                                </Form.Label>

                                <div className=" d-flex flex-column gap-2">
                                    <Form.Control
                                        type="file"
                                        accept="image/*"
                                        id="editBedIconUpload"
                                        className="d-none"
                                        onChange={(e) => {
                                            const file = e.target.files[0];
                                            if (!file) return;

                                            setIcon(file);
                                            setIconPreview(URL.createObjectURL(file));
                                            setIconError("");
                                        }}
                                    />

                                    <Form.Label
                                        htmlFor="editBedIconUpload"
                                        className="btn btn-warning text-white mb-0"

                                        style={{ width: "fit-content", cursor: "pointer", backgroundColor: "#13626f", border: "none" }}
                                    >
                                        Change Icon
                                    </Form.Label>


                                    {iconPreview && (
                                        <div
                                            style={{
                                                width: "90px",
                                                height: "90px",
                                                border: "1px dashed #ccc",
                                                borderRadius: "6px",
                                                overflow: "hidden",
                                            }}
                                            className="d-flex align-items-center justify-content-center"
                                        >
                                            <img
                                                src={iconPreview}
                                                alt="icon-preview"
                                                style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "contain",
                                                }}
                                            />
                                        </div>
                                    )}

                                    {iconError && (
                                        <div className="text-danger small">
                                            {iconError}
                                        </div>
                                    )}
                                </div>
                            </Col>
                        </Row>


                        <Row>
                            <Col className="d-flex justify-content-center gap-3">
                                <Button
                                    type="button"
                                    style={{ minWidth: "120px", borderColor: "#13626f", color: "#13626f", background: "none" }}
                                    onClick={() => navigate(-1)}
                                >
                                    Cancel
                                </Button>

                                <Button
                                    type="submit"
                                    variant="warning"
                                    className="text-white"
                                    style={{ minWidth: "120px", backgroundColor: "#13626f", border: "none" }}

                                >
                                    Update
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </Card>
            </Container>
        </>
    );
}
